import { Book } from '@fable/types'
import BookGridItem from '../bookstore/BookGridItem'
import { css, useTheme } from '@fable/theme'

interface Props {
  books: Book[]
}

export const PersonBooks = ({ books }: Props) => {
  const { colors, mediaQueries } = useTheme()

  return (
    <div
      data-testid="person-info-books"
      className={css`
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 16px;
        @media only screen and (min-width: 620px) {
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }
        ${mediaQueries.tabletL} {
          grid-template-columns: repeat(1, 1fr);
        }
        ${mediaQueries.desktop} {
          grid-template-columns: repeat(2, 1fr);
        }
      `}
    >
      {books.map((book, i) => (
        <BookGridItem
          key={i}
          book={book}
          palette={{ title: colors.uiGraphite }}
        />
      ))}
    </div>
  )
}
